// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-components-UserManagement-FilterBar__main--obcaN"};